module.exports = __webpack_public_path__ + "img/S510.2a52e548.jpg";